import { RefreshCw, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { onSwUpdateAvailable, refreshToLatest } from "../lib/sw-update.ts";

/**
 * "A new version is available" banner. Shown to logged-in staff when the service
 * worker has fetched a newer build — tapping refresh applies it. Non-blocking
 * and dismissible so it never interrupts work; the not-found guard still pulls
 * the fresh bundle if they navigate to a brand-new route before refreshing.
 */
export function UpdateBanner() {
	const { t } = useTranslation("common");
	const [show, setShow] = useState(false);

	useEffect(() => onSwUpdateAvailable(setShow), []);

	if (!show) return null;

	return (
		<output className="fixed inset-x-3 bottom-[calc(4rem+env(safe-area-inset-bottom))] sm:bottom-4 sm:inset-x-auto sm:end-4 z-50 flex items-center gap-3 rounded-xl border border-brand-200 dark:border-brand-800 bg-card shadow-elevated px-4 py-3 animate-slide-up">
			<RefreshCw
				className="size-5 text-brand-600 shrink-0"
				strokeWidth={2}
				aria-hidden
			/>
			<div className="min-w-0 text-sm">
				<p className="font-semibold text-foreground">
					{t("update.title", { defaultValue: "نسخة جديدة متوفّرة" })}
				</p>
				<p className="text-xs text-muted-foreground">
					{t("update.body", { defaultValue: "حدّث للحصول على آخر التحسينات." })}
				</p>
			</div>
			<button
				type="button"
				onClick={() => refreshToLatest()}
				className="shrink-0 rounded-lg bg-brand-600 px-3 py-1.5 text-sm font-semibold text-white hover:bg-brand-700"
			>
				{t("update.action", { defaultValue: "تحديث" })}
			</button>
			<button
				type="button"
				onClick={() => setShow(false)}
				aria-label={t("actions.dismiss", { defaultValue: "إغلاق" })}
				className="shrink-0 rounded-md p-1 text-muted-foreground hover:bg-muted hover:text-foreground"
			>
				<X className="size-4" strokeWidth={2} aria-hidden />
			</button>
		</output>
	);
}
